import { Injectable } from '@angular/core';
import { IDetailedWarning } from "libraries/service/resources/booking/interfaces/IGetBookings";
import {
    IAirCreateBookingRequest,
    IAirCreateBookingRequestPayment,
    IAirCreateBookingRequestPaymentPrice,
    IAirCreateBookingRequestPaymentPriceCostCurrency
} from "libraries/service/resources/model/booking/air/IAirCreateBooking";
import { IAirBookingResponse } from "libraries/service/resources/model/booking/air/IAirBookingResponse";
import { Params } from "@angular/router";

export interface IBookingErrorPriceChangedResponse {
    detailedWarningArray: IDetailedWarning[];
    payment: IBookingErrorPriceChangedResponsePayment[];
    transactionId: string;
}

export interface IBookingErrorPriceChangedResponsePayment {
    total: IAirCreateBookingRequestPaymentPriceCostCurrency;
}

/**
 * Used to transmit CreateBooking warning message between two pages.
 */
@Injectable()
export class CreateBookingWarningMessageService {

    private warningMessage: string;
    private warningNewPrice: IAirCreateBookingRequestPaymentPriceCostCurrency;
    private warningRequestPrice: IAirCreateBookingRequestPaymentPriceCostCurrency;
    private warningSqaRouteParams: Params;
    private warningArray: IDetailedWarning[];
    private cbNewRequestAfterPriceChanged: IAirCreateBookingRequest;

    public resetAll(): void {
        this.warningMessage = null;
        this.warningArray = null;
    }

    public setWarningMessage(warningMessage: string): void {
        this.warningMessage = warningMessage;
    }
    public setWarningNewPrice(payment: IBookingErrorPriceChangedResponsePayment[]): void {
        if(payment?.length && payment[0].total){
            this.warningNewPrice = payment[0].total;
        }else{
            /* #35926
            this.warningMessage = null;
            replaced by
            this.warningNewPrice = null;
             */
            this.warningNewPrice = null;
        }
    }
    public setWarningSqaRouteParams(routeParams: Params): void {
        this.warningSqaRouteParams = routeParams ? routeParams : null;
    }
    public setWarningRequestPrice(request: IAirCreateBookingRequest): void {
        this.warningRequestPrice = request?.payment?.price?.cost?.currency ? request.payment.price.cost.currency : null;
    }

    public setWarningArray(warningArray: IDetailedWarning[]): void {
        this.warningArray = warningArray;
    }


    public setCbNewRequestAfterPriceChanged(oldRequest: IAirCreateBookingRequest, priceChangeResponse: IBookingErrorPriceChangedResponse): void {
        const hasPriceChangedError: boolean = Boolean(
            priceChangeResponse.detailedWarningArray?.length &&
            priceChangeResponse.detailedWarningArray.find((warning: IDetailedWarning): boolean => {
                return warning.wCode === 'WRN_PRICE_HAS_CHANGED' || warning.code === 'WRN_PRICE_HAS_CHANGED';
            })
        );
        if (hasPriceChangedError) {
            const newTotal: IAirCreateBookingRequestPaymentPriceCostCurrency = priceChangeResponse.payment[0].total;
            this.cbNewRequestAfterPriceChanged = {
                ...oldRequest,
                payment: {
                    ...oldRequest.payment,
                    price: {
                        cost: {
                            currency: newTotal
                        }
                    }
                },
                transactionId: priceChangeResponse.transactionId,
                // #32562 if price change needed to it here
                price: {
                    ...oldRequest.price,
                    value: newTotal.value,
                    total: newTotal.value,
                }
            };
        } else {
            this.cbNewRequestAfterPriceChanged = null;
        }


    }

    public getWarningMessage(): string {
        const lastMessage: string = this.warningMessage;
        this.warningMessage = null;
        return lastMessage;
    }

    public getWarningNewPrice(): IAirCreateBookingRequestPaymentPriceCostCurrency {
        const output: IAirCreateBookingRequestPaymentPriceCostCurrency = this.warningNewPrice;
        this.warningNewPrice = null;
        return output;
    }

    public getWarningRequestPrice(): IAirCreateBookingRequestPaymentPriceCostCurrency {
        const output: IAirCreateBookingRequestPaymentPriceCostCurrency = this.warningRequestPrice;
        this.warningRequestPrice = null;
        return output;
    }

    public getWarningSqaRouteParams(): Params {
        return this.warningSqaRouteParams;
    }

    public getWarningArray(): IDetailedWarning[] {
        const warningArray: IDetailedWarning[] = this.warningArray;
        this.warningArray = null;
        return warningArray;
    }

    public getCbNewRequestAfterPriceChanged(): IAirCreateBookingRequest {
        if (this.cbNewRequestAfterPriceChanged) {
            const cbNewRequestAfterPriceChanged: IAirCreateBookingRequest = this.cbNewRequestAfterPriceChanged;
            this.cbNewRequestAfterPriceChanged = null;
            return cbNewRequestAfterPriceChanged;
        }
        return null;
    }
}
